import { useTenantNavigate } from '@app-store'
import { RouteObject } from 'react-router-dom'
import BenefitVerification from '../pages/Workflow/WorkflowReview.page'
import WorkflowBreadCrumbs from '../components/common/WorkflowBreadCrumbs'
import CaseIdBreadCrumbs from '../components/common/CaseIdBreadCrumbs'
import { useEffect } from 'react'
import { useAppSelector } from '../utils/agent.store'

const WorkflowError = () => {
  const navigate = useTenantNavigate()
  const tenantid = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )

  const navObjectStringified = localStorage.getItem('workflowNavObject')
  const navObject = navObjectStringified ? JSON.parse(navObjectStringified) : {}

  useEffect(() => {
    if (navObjectStringified && navObject?.[tenantid?.toString() ?? '']) {
      navigate(
        `/manage-queue/dynamic-queue/${
          navObject?.[tenantid?.toString() ?? '']?.entityId
        }/${navObject?.[tenantid?.toString() ?? '']?.layoutId}/${
          navObject?.[tenantid?.toString() ?? '']?.Id
        }`
      )
    } else {
      navigate(-1)
    }
  }, [])
  // Todo: Implement a redirect to queue page from which the workflow was accessed, and should be able to go back to the same queue page after the workflow is reviewed
  return <div>Workfow Index Page</div>
}

const workflowRoutes: RouteObject = {
  path: 'entity/:entityId/workflow',
  handle: {
    crumb: () => <WorkflowBreadCrumbs />,
  },
  children: [
    {
      path: '',
      element: <WorkflowError />,
    },
    {
      path: 'review/:caseId',
      element: <BenefitVerification />,
      handle: {
        crumb: () => <CaseIdBreadCrumbs />,
      },
    },
  ],
}

export default workflowRoutes
